/* Coffee Break Puzzles: a landing screen for today's puzzle, then the puzzle itself on one screen.
   Talks to the puzzle server set in the section's API setting. */
(function () {
  'use strict';
  var root = document.querySelector('[data-decca-break]');
  if (!root) return;
  var API = String(root.getAttribute('data-api') || '').replace(/\/+$/, '');
  var TOKEN_KEY = 'decca_break_token';
  var SOURCE_KEY = 'decca_break_source';
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var COPY = {};
  try { COPY = JSON.parse((document.querySelector('[data-brk-copy]') || {}).textContent || '{}'); } catch (e) {}
  function copy(k, d) { return COPY[k] != null && COPY[k] !== '' ? COPY[k] : d; }
  function instagram() { return copy('instagram_url', 'https://www.instagram.com/deccadecaf'); }

  // ---------- helpers ----------
  function store(k, v) {
    try {
      if (v === undefined) return localStorage.getItem(k);
      if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function pad(n) { return String(n).padStart(2, '0'); }
  function fmtTime(s) { s = Math.max(0, Math.round(s || 0)); return Math.floor(s / 60) + ':' + pad(s % 60); }
  function fmtClock(s) { s = Math.max(0, Math.floor(s || 0)); return pad(Math.floor(s / 60)) + ':' + pad(s % 60); }
  function fullDate(date) {
    return new Date(date + 'T12:00:00Z').toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
  }
  var ICON = {
    pause: '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>',
    play: '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>',
    lock: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>'
  };
  function fmtCountdown(ms) {
    var s = Math.max(0, Math.round(ms / 1000));
    return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
  }
  function breakNo(id) { return '#' + String(id).padStart(3, '0'); }
  function dayName(date) { return DAYS[new Date(date + 'T12:00:00Z').getUTCDay()]; }
  function longDate(date) {
    return new Date(date + 'T12:00:00Z').toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', timeZone: 'UTC' });
  }
  function norm(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }

  function source() {
    var s = null;
    try { s = sessionStorage.getItem(SOURCE_KEY); } catch (e) {}
    if (s) return s;
    var q = new URLSearchParams(location.search);
    s = q.get('utm_source') || q.get('src');
    if (!s) {
      var ref = document.referrer || '';
      ['instagram', 'tiktok', 'linkedin', 'facebook', 'google'].forEach(function (n) { if (!s && ref.indexOf(n) !== -1) s = n; });
    }
    s = (s || 'site').toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 32) || 'site';
    try { sessionStorage.setItem(SOURCE_KEY, s); } catch (e) {}
    return s;
  }
  source();

  function api(method, path, body) {
    var headers = { 'Content-Type': 'application/json' };
    var t = store(TOKEN_KEY);
    if (t) headers.Authorization = 'Bearer ' + t;
    var debug = root.getAttribute('data-debug-now');
    if (debug) headers['X-Debug-Now'] = debug;
    return fetch(API + path, { method: method, headers: headers, body: body ? JSON.stringify(body) : undefined })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) { var e = new Error(data.error || 'Something went wrong.'); e.status = res.status; throw e; }
          return data;
        });
      }, function () {
        var e = new Error('Couldn’t reach the puzzle. Check your connection and try again.'); e.status = 0; throw e;
      });
  }

  // ---------- state ----------
  var S = { player: null, nextRelease: null, puzzle: null, solve: null, check: null, draft: null, grid: null, dir: 'across', focus: -1, view: 'puzzle' };

  function draftKey(id) { return 'decca_break_draft_' + id; }
  function loadDraft(p, g) {
    var d = null;
    try { d = JSON.parse(store(draftKey(p.id)) || 'null'); } catch (e) {}
    if (!d || typeof d.letters !== 'string' || d.letters.length !== g.count) d = { letters: Array(g.count + 1).join(' '), started: null };
    return d;
  }
  function saveDraft() { if (S.puzzle && S.draft) store(draftKey(S.puzzle.id), JSON.stringify(S.draft)); }
  function touch() { if (S.draft && !S.draft.started && !S.solve) { S.draft.started = Date.now(); saveDraft(); } }
  function elapsed() {
    if (S.solve && S.solve.seconds != null) return S.solve.seconds;
    if (!S.draft || !S.draft.started) return 0;
    return ((S.pausedAt || Date.now()) - S.draft.started) / 1000;
  }
  function gaveUp() { return !!(S.solve && S.solve.revealed && !S.solve.correct); }
  function solved() { return !!((S.solve && S.solve.correct) || (S.check && S.check.correct)); }
  function locked() { return gaveUp() || solved(); }

  // ---------- grid model ----------
  function model(part) {
    var R = part.rows, C = part.cols, cells = part.cells;
    var open = function (r, c) { return r >= 0 && c >= 0 && r < R && c < C && cells[r * C + c] !== '#'; };
    var g = { R: R, C: C, open: open, nums: [], idx: [], count: 0, acrossOf: [], downOf: [], words: { across: {}, down: {} }, order: [], clue: { across: {}, down: {} } };
    for (var i = 0; i < R * C; i++) g.idx[i] = cells[i] === '#' ? -1 : g.count++;
    var n = 0;
    for (var r = 0; r < R; r++) for (var c = 0; c < C; c++) {
      var at = r * C + c; g.nums[at] = 0;
      if (!open(r, c)) continue;
      var a = !open(r, c - 1) && open(r, c + 1), d = !open(r - 1, c) && open(r + 1, c);
      if (a || d) g.nums[at] = ++n;
      if (a) { var wa = []; for (var cc = c; open(r, cc); cc++) { wa.push(r * C + cc); g.acrossOf[r * C + cc] = n; } g.words.across[n] = wa; }
      if (d) { var wd = []; for (var rr = r; open(rr, c); rr++) { wd.push(rr * C + c); g.downOf[rr * C + c] = n; } g.words.down[n] = wd; }
    }
    var clues = part.clues || {};
    ['across', 'down'].forEach(function (dir) {
      (clues[dir] || []).forEach(function (cl) { g.clue[dir][cl.n] = cl.text; g.order.push({ dir: dir, n: cl.n }); });
    });
    return g;
  }
  function wordAt(i, dir) { var g = S.grid; var n = dir === 'across' ? g.acrossOf[i] : g.downOf[i]; return n ? { n: n, cells: g.words[dir][n] } : null; }

  // ---------- frame ----------
  function fit() {
    var top = root.getBoundingClientRect().top + window.scrollY;
    root.style.setProperty('--brk-h', Math.max(520, window.innerHeight - top) + 'px');
  }
  window.addEventListener('resize', fit);

  function weekDots(week) {
    if (!week) return '';
    return '<div class="brk-dots" aria-label="This week">' + week.map(function (d) {
      var lab = { solved: 'solved', late: 'solved late', missed: 'missed', today: 'today', upcoming: 'coming up', none: 'no puzzle' }[d.state] || d.state;
      return '<span class="is-' + d.state + '" title="' + esc(dayName(d.date) + ': ' + lab) + '"><small>' + esc(dayName(d.date).charAt(0)) + '</small><b>' + (d.letter ? esc(d.letter) : '') + '</b></span>';
    }).join('') + '</div>';
  }

  // ---------- top bar ----------
  function acct() {
    var pl = S.player;
    return pl ? '<span class="brk-tb__streak" title="Best ' + pl.best_streak + '"><b>' + pl.streak + '</b> day streak</span>' :
      '<button type="button" class="brk-tb__signin" data-gate="login">Sign in</button>';
  }
  function toolbar(o) {
    return '<div class="brk-tb">' +
      '<div class="brk-tb__left"><a class="brk-tb__back" href="' + o.back + '"><span aria-hidden="true">‹</span> Back</a>' +
        (o.label ? '<span class="brk-tb__meta">' + o.label + '</span>' : '') + '</div>' +
      '<div class="brk-tb__clock">' + (o.timer ? '<span data-timer aria-label="Solve time">' + fmtClock(elapsed()) + '</span>' +
        '<button type="button" class="brk-tb__icon" data-pause aria-label="Pause">' + ICON.pause + '</button>' : '') + '</div>' +
      '<div class="brk-tb__right">' + (o.help ? '<button type="button" class="brk-tb__icon" data-help aria-label="How to play">?</button>' : '') +
        '<span data-acct>' + acct() + '</span></div>' +
    '</div>';
  }
  function puzzleTop(p) {
    return toolbar({ back: p.live ? '#' : '#archive', label: '<b>' + esc(breakNo(p.id)) + '</b>' + esc(p.title) + ' · ' + esc(p.difficulty), timer: true, help: true });
  }
  function wireGates(scope) {
    scope.querySelectorAll('[data-gate]').forEach(function (b) { b.addEventListener('click', function () { openGate(b.getAttribute('data-gate')); }); });
  }
  function wireCommon() {
    wireGates(root);
    var so = root.querySelector('[data-signout]');
    if (so) so.addEventListener('click', function () { store(TOKEN_KEY, null); S.player = null; S.solve = null; S.check = null; location.hash = ''; route(); });
    var pz = root.querySelector('[data-pause]');
    if (pz) pz.addEventListener('click', function () { setPaused(!S.pausedAt); });
    var rs = root.querySelector('[data-resume]');
    if (rs) rs.addEventListener('click', function () { setPaused(false); });
    var hp = root.querySelector('[data-help]');
    if (hp) hp.addEventListener('click', openHelp);
    var wk = root.querySelector('[data-weekly]');
    if (wk) wk.addEventListener('click', weeklyInfo);
  }

  function frame(center, right, top) {
    S.pausedAt = null;
    root.innerHTML = '<div class="brk-play">' + (top || toolbar({ back: '#' })) +
      '<div class="brk-app' + (right ? '' : ' is-one') + '">' + center + (right || '') +
        '<div class="brk-pausecard" hidden><div class="label accent">Paused</div><p class="brk-pausecard__h">Your coffee<br>will wait.</p>' +
        '<button type="button" class="btn-orange" data-resume>Resume</button></div>' +
      '</div></div>';
    root.setAttribute('aria-busy', 'false');
    wireCommon();
    fit();
  }
  function refreshTop() {
    var a = root.querySelector('[data-acct]');
    if (a) { a.innerHTML = acct(); wireGates(a); }
  }
  function loading() { root.setAttribute('aria-busy', 'true'); }
  function errorView(err, retry) {
    frame('<main class="brk-main brk-main--msg"><div class="label accent">Hold on</div><p class="brk-main__msg">' + esc(err.message) + '</p><button type="button" class="btn-orange" data-retry>Try again</button></main>');
    root.querySelector('[data-retry]').addEventListener('click', retry);
  }

  // ---------- pause ----------
  function setPaused(on) {
    var app = root.querySelector('.brk-app');
    if (!app || on === !!S.pausedAt) return;
    if (on) {
      if (locked()) return;
      S.pausedAt = Date.now();
      if (document.activeElement && root.contains(document.activeElement)) document.activeElement.blur();
    } else {
      if (S.draft && S.draft.started) { S.draft.started += Date.now() - S.pausedAt; saveDraft(); }
      S.pausedAt = null;
    }
    app.classList.toggle('is-paused', on);
    [].forEach.call(app.children, function (c) { if (!c.classList.contains('brk-pausecard')) c.inert = on; });
    var card = app.querySelector('.brk-pausecard'); card.hidden = !on;
    var b = root.querySelector('[data-pause]');
    if (b) { b.innerHTML = on ? ICON.play : ICON.pause; b.setAttribute('aria-label', on ? 'Resume' : 'Pause'); }
    if (on) card.querySelector('button').focus();
    else if (S.mode === 'crossword') setFocus(S.focus >= 0 ? S.focus : firstEmpty(), true);
    else if (S.mode === 'sudoku') { var fi = cellInput(S.sq.focus); if (fi) fi.focus({ preventScroll: true }); }
    tick();
  }
  function endPause() {
    if (!S.pausedAt) return;
    if (S.draft && S.draft.started) { S.draft.started += Date.now() - S.pausedAt; saveDraft(); }
    S.pausedAt = null;
  }

  // ---------- landing screen ----------
  function puzzleType(p) {
    if (!p) return 'none';
    if (/weekly/i.test(p.kind || '')) return 'weekly';
    var t = p.parts && p.parts.length === 1 ? p.parts[0].type : '';
    return t === 'grid' ? 'crossword' : t === 'sudoku' ? 'sudoku' : 'other';
  }
  // A small stack of tiles that hints at today's puzzle. "#" is a dark tile, "" a blank one, null a gap.
  function icon(p) {
    var type = puzzleType(p), cols = 3, tiles;
    if (type === 'crossword') tiles = ['#', 'D', null, 'C', 'A', 'N', null, 'Y', '#'];
    else if (type === 'sudoku') tiles = ['3', '', '1', '', '2', '', '1', '', '3'];
    else if (type === 'weekly') {
      cols = 2;
      var got = ((S.player && S.player.week) || []).map(function (d) { return d.letter; }).filter(Boolean);
      tiles = [0, 1, 2, 3].map(function (k) { return got[k] || '?'; });
    }
    else if (type === 'other') tiles = [null, '?', null, '3', 'P', 'M', null, null, null];
    else tiles = ['3', 'P', 'M'];
    return '<div class="brk-icon" aria-hidden="true"><div class="brk-icon__grid" style="--n:' + cols + '">' + tiles.map(function (t) {
      return t === null ? '<i class="is-gap"></i>' : t === '#' ? '<i class="is-dark"></i>' : '<i>' + esc(t) + '</i>';
    }).join('') + '</div></div>';
  }
  // The name on the landing screen. It changes with each day's puzzle.
  function typeName(p) {
    var type = puzzleType(p);
    return type === 'crossword' ? 'Crossword' : type === 'sudoku' ? 'Sudoku' : type === 'weekly' ? 'The weekly puzzle' : p.kind;
  }
  function hasDraft(p) {
    try { var d = JSON.parse(store(draftKey(p.id)) || 'null'); return !!(d && d.started); } catch (e) { return false; }
  }

  function renderSplash() {
    var d = S.today || {}, p = d.puzzle, sv = d.solve, pl = S.player;
    S.view = 'splash'; S.puzzle = null; S.mode = null;
    var type = puzzleType(p);
    var done = !!(sv && (sv.correct || sv.revealed)), going = !done && !!(sv || (p && hasDraft(p)));
    var play = done ? 'See today’s puzzle' : going ? 'Keep solving' : type === 'weekly' ? 'Play the weekly puzzle' : 'Play today’s puzzle';
    var btns = p ? '<a class="brk-sp__btn is-main" href="#play">' + play + '</a>' :
      (pl ? '' : '<button type="button" class="brk-sp__btn is-main" data-gate="notify">Email me when it drops</button>');
    if (type !== 'weekly') btns += '<button type="button" class="brk-sp__btn" data-weekly>The weekly puzzle ' + ICON.lock + '</button>';
    btns += '<a class="brk-sp__btn" href="#archive">See all puzzles</a>';
    var foot = pl ?
      '<div class="brk-sp__me">' + weekDots(pl.week) +
        '<p class="brk-sp__acct"><b>' + pl.streak + '-day streak</b> · Best ' + pl.best_streak + ' · <button type="button" class="brk-sp__out" data-signout>Sign out</button></p></div>' :
      '<button type="button" class="brk-sp__btn is-signin" data-gate="login"><span class="brk-wide">Sign in to keep your streak and unlock past answers →</span><span class="brk-narrow">Sign in to keep your streak &amp; answers →</span></button>';
    root.innerHTML =
      '<div class="brk-sp">' +
        (p ? '<p class="brk-sp__date">' + esc(fullDate(p.date)) + '<span>' + esc(breakNo(p.id)) + '</span></p>' : '') +
        '<div class="brk-sp__brand">' + esc(copy('eyebrow', 'Coffee Break Puzzles')) + '</div>' +
        '<h1 class="brk-sp__title">' + (p ? '<span class="brk-sp__kicker">Today’s puzzle:</span>' + esc(typeName(p)) : 'First puzzle') + '</h1>' +
        '<p class="brk-sp__lead">' + esc(copy('lead', 'The only thing in this coffee break that will keep you up tonight is the puzzle.')) + '</p>' +
        '<p class="brk-sp__sub">' + esc(copy('sub', 'A new one every weekday at 3 PM ET, about five minutes long. Drink a can of Decca while you solve it. First to finish Friday’s puzzle and DM it to us wins that week’s prize.')) + '</p>' +
        icon(p) +
        '<p class="brk-sp__meta">' + (p ? '“' + esc(p.title) + '” · ' + esc(p.difficulty) + ' · About 5 minutes' : 'Drops at 3 PM ET · <span data-countdown></span>') + '</p>' +
        '<div class="brk-sp__btns">' + btns + '</div>' +
        foot +
      '</div>';
    root.setAttribute('aria-busy', 'false');
    wireCommon();
    fit();
    tick();
  }

  function weeklyInfo() {
    var pl = S.player;
    var pop = popup(
      '<div class="brk-pop" role="dialog" aria-modal="true" aria-labelledby="brk-wk-h">' +
        '<div class="label accent">Opens Friday at 3 PM ET</div>' +
        '<h2 id="brk-wk-h" class="brk-pop__h">The weekly <span class="accent">puzzle.</span></h2>' +
        '<p class="brk-small">' + esc(copy('point_1_text', 'Every puzzle you solve Monday through Thursday earns one letter. On Friday, those letters unlock the weekly puzzle. The first person to solve it and DM us the finished puzzle on Instagram wins that week’s prize.')) + '</p>' +
        (pl && pl.week ? '<div class="brk-pop__row"><span class="label">Your<br>letters</span>' + weekDots(pl.week) + '</div>' : '') +
        '<a class="brk-ig" href="' + esc(instagram()) + '" target="_blank" rel="noopener">Follow ' + esc(copy('instagram_handle', '@deccadecaf')) + ' →</a>' +
        (pl ? '<button type="button" class="btn-orange" data-close>Got it</button>' :
          '<button type="button" class="btn-orange" data-signin>Sign in to collect letters →</button><button type="button" class="brk-link" data-close>Not now</button>') +
      '</div>');
    var si = pop.el.querySelector('[data-signin]');
    if (si) si.addEventListener('click', function () { pop.close(); openGate('login'); });
  }

  function openHelp() {
    popup(
      '<div class="brk-pop" role="dialog" aria-modal="true" aria-labelledby="brk-help-h">' +
        '<div class="label accent">' + esc(S.puzzle ? S.puzzle.kind : 'Coffee Break Puzzles') + '</div>' +
        '<h2 id="brk-help-h" class="brk-pop__h">How to <span class="accent">play.</span></h2>' +
        (S.how || []).map(function (l) { return '<p class="brk-small">' + esc(l) + '</p>'; }).join('') +
        '<p class="brk-small"><b>The weekly puzzle.</b> ' + esc(copy('point_1_text', 'Every puzzle you solve Monday through Thursday earns one letter. On Friday, those letters unlock the weekly puzzle. The first person to solve it and DM us the finished puzzle on Instagram wins that week’s prize.')) + '</p>' +
        '<button type="button" class="btn-orange" data-close>Back to the puzzle</button>' +
      '</div>');
  }

  // ---------- routing ----------
  function route() {
    endPause();
    var h = location.hash.replace('#', '');
    var m = h.match(/^break-(\d+)$/);
    if (h === 'archive') return showArchive();
    if (m) return showPuzzle(Number(m[1]));
    return showToday(h === 'play');
  }
  window.addEventListener('hashchange', route);

  function withPlayer(next) {
    if (S.player || !store(TOKEN_KEY)) return next();
    api('GET', '/api/me').then(function (m) { S.player = m.player; next(); }, function (e) { if (e.status === 401) store(TOKEN_KEY, null); next(); });
  }

  function showToday(play) {
    loading();
    api('GET', '/api/today').then(function (d) {
      S.player = d.player; S.nextRelease = d.next_release_at; S.today = d;
      if (!d.player && store(TOKEN_KEY)) store(TOKEN_KEY, null);
      if (play && d.puzzle) return openPuzzle(d.puzzle, d.solve);
      renderSplash();
    }, function (e) { errorView(e, function () { showToday(play); }); });
  }
  function showPuzzle(id) {
    loading();
    withPlayer(function () {
      api('GET', '/api/puzzles/' + id).then(function (d) { openPuzzle(d.puzzle, d.solve); }, function (e) {
        if (e.status === 401) { location.hash = ''; openGate('archive'); return; }
        errorView(e, function () { showPuzzle(id); });
      });
    });
  }

  // ---------- puzzle ----------
  function openPuzzle(p, solve) {
    var parts = p.parts || [];
    if (parts.length === 1 && parts[0].type === 'sudoku') return openSudoku(p, solve);
    var part = parts.length === 1 && parts[0].type === 'grid' ? parts[0] : null;
    if (!part) return openForm(p, solve);
    S.mode = 'crossword';
    S.puzzle = p; S.solve = solve; S.check = null; S.view = 'puzzle';
    S.part = part; S.partIndex = p.parts.indexOf(part);
    S.grid = model(part);
    S.draft = loadDraft(p, S.grid);
    var sub = solve && solve.submission && solve.submission[S.partIndex];
    if (typeof sub === 'string' && sub.length === S.grid.count) S.draft.letters = sub;
    if (gaveUp() && p.answers) S.draft.letters = norm(p.answers[S.partIndex]);
    S.dir = 'across'; S.focus = -1;
    renderPuzzle();
    if (solve) applyResults(solve.results);
    if (gaveUp()) markRevealed();
    setFocus(firstEmpty(), !locked() && window.matchMedia('(hover: hover)').matches);
  }

  function firstEmpty() {
    var g = S.grid;
    for (var i = 0; i < g.R * g.C; i++) if (g.idx[i] >= 0 && !(S.draft.letters[g.idx[i]] || '').trim()) return i;
    for (var k = 0; k < g.R * g.C; k++) if (g.idx[k] >= 0) return k;
    return 0;
  }

  function renderPuzzle() {
    var p = S.puzzle, g = S.grid;
    var cells = '';
    for (var i = 0; i < g.R * g.C; i++) {
      if (g.idx[i] < 0) { cells += '<div class="brk-cell is-block" aria-hidden="true"></div>'; continue; }
      var r = Math.floor(i / g.C), c = i % g.C, ch = (S.draft.letters[g.idx[i]] || ' ').trim();
      cells += '<div class="brk-cell" data-cell="' + i + '">' + (g.nums[i] ? '<span class="brk-num">' + g.nums[i] + '</span>' : '') +
        '<input id="brk-c-' + i + '" inputmode="text" autocomplete="off" autocapitalize="characters" spellcheck="false" enterkeyhint="next" aria-label="Row ' + (r + 1) + ', column ' + (c + 1) + (g.nums[i] ? ', ' + g.nums[i] : '') + '" value="' + esc(ch) + '"></div>';
    }
    var list = function (dir) {
      var items = (S.part.clues && S.part.clues[dir]) || [];
      return '<div class="brk-clues__col"><h3>' + (dir === 'across' ? 'Across' : 'Down') + '</h3><ol>' +
        items.map(function (cl) { return '<li data-dir="' + dir + '" data-n="' + cl.n + '"><b>' + cl.n + '</b><span>' + esc(cl.text) + '</span></li>'; }).join('') + '</ol></div>';
    };
    var center =
      '<main class="brk-main">' +
        '<div class="brk-cluebar" data-cluebar>' +
          '<button type="button" class="brk-cluebar__nav" data-prev aria-label="Previous clue">‹</button>' +
          '<button type="button" class="brk-cluebar__text" data-flip aria-live="polite" aria-label="Current clue. Select to switch direction."></button>' +
          '<button type="button" class="brk-cluebar__nav" data-next aria-label="Next clue">›</button>' +
        '</div>' +
        '<div class="brk-gridbox"><div class="brk-grid" style="--cols:' + g.C + ';--rows:' + g.R + '" role="grid" aria-label="Crossword, ' + g.R + ' by ' + g.C + '">' + cells + '</div></div>' +
        boardActions() +
      '</main>';
    var right = '<section class="brk-clues" aria-label="Clues">' + list('across') + list('down') + '</section>';
    S.how = [
      'Click a square and type. Click it again, or press the space bar, to switch between across and down.',
      'Tab, or the arrows on the clue bar, jumps to the next clue.',
      'Press Enter or Check answers when you’re done. Wrong squares turn red.',
      'Solve it to earn a letter for Friday’s weekly puzzle.'
    ];
    frame(center, right, puzzleTop(p));
    wire();
    updateButtons();
    tick();
  }

  function cellInput(i) { return document.getElementById('brk-c-' + i); }

  function setLetter(i, ch) {
    var g = S.grid, s = S.draft.letters.split('');
    s[g.idx[i]] = ch || ' ';
    S.draft.letters = s.join('');
    var inp = cellInput(i); if (inp) inp.value = ch || '';
    var cell = inp && inp.parentNode; if (cell) cell.classList.remove('is-good', 'is-bad');
    touch(); saveDraft();
  }

  function setFocus(i, move) {
    var g = S.grid;
    if (i < 0 || g.idx[i] < 0) return;
    if (!wordAt(i, S.dir)) S.dir = S.dir === 'across' ? 'down' : 'across';
    S.focus = i;
    if (move) { var inp = cellInput(i); if (inp && document.activeElement !== inp) inp.focus({ preventScroll: true }); }
    highlight();
  }

  function highlight() {
    var w = S.focus >= 0 ? wordAt(S.focus, S.dir) : null;
    var other = S.dir === 'across' ? 'down' : 'across';
    var x = S.focus >= 0 ? wordAt(S.focus, other) : null;
    root.querySelectorAll('.brk-cell[data-cell]').forEach(function (el) {
      var i = Number(el.getAttribute('data-cell'));
      el.classList.toggle('is-word', !!(w && w.cells.indexOf(i) !== -1));
      el.classList.toggle('is-focus', i === S.focus);
    });
    root.querySelectorAll('.brk-clues li').forEach(function (li) {
      var dir = li.getAttribute('data-dir'), n = Number(li.getAttribute('data-n'));
      var on = !!w && dir === S.dir && n === w.n, cross = !!x && dir === other && n === x.n;
      li.classList.toggle('is-on', on);
      li.classList.toggle('is-cross', cross);
      var box = li.parentNode;
      if ((on || cross) && box.scrollHeight > box.clientHeight) {
        var top = li.offsetTop;
        if (top < box.scrollTop || top > box.scrollTop + box.clientHeight - li.offsetHeight) box.scrollTop = top - 8;
      }
    });
    var bar = root.querySelector('[data-flip]');
    if (bar) bar.innerHTML = w ? '<b>' + w.n + ' ' + (S.dir === 'across' ? 'Across' : 'Down') + ':</b><span>' + esc(S.grid.clue[S.dir][w.n] || '') + '</span>' : '';
  }

  function stepCell(i, dr, dc) {
    var g = S.grid, r = Math.floor(i / g.C) + dr, c = (i % g.C) + dc;
    while (r >= 0 && c >= 0 && r < g.R && c < g.C) { if (g.open(r, c)) return r * g.C + c; r += dr; c += dc; }
    return i;
  }

  function nextClue(delta, skipFull) {
    var order = S.grid.order; if (!order.length) return;
    var w = wordAt(S.focus, S.dir), k = 0;
    if (w) for (var j = 0; j < order.length; j++) if (order[j].dir === S.dir && order[j].n === w.n) { k = j; break; }
    var nx = order[(k + delta + order.length) % order.length];
    if (skipFull) {
      for (var t = 1; t <= order.length; t++) {
        var cand = order[(k + delta * t + order.length * t) % order.length], cs = S.grid.words[cand.dir][cand.n];
        if (cs && cs.some(function (c) { return !(S.draft.letters[S.grid.idx[c]] || '').trim(); })) { nx = cand; break; }
      }
    }
    var cells = S.grid.words[nx.dir][nx.n];
    if (!cells) return;
    S.dir = nx.dir;
    var target = cells[0];
    for (var m = 0; m < cells.length; m++) if (!(S.draft.letters[S.grid.idx[cells[m]]] || '').trim()) { target = cells[m]; break; }
    setFocus(target, true);
  }

  // After typing in square i: the next empty square in the word, or the next clue once the word is full.
  function advance(i) {
    var w = wordAt(i, S.dir); if (!w) return i;
    var k = w.cells.indexOf(i);
    for (var m = k + 1; m < w.cells.length; m++) if (!(S.draft.letters[S.grid.idx[w.cells[m]]] || '').trim()) return w.cells[m];
    if (S.draft.letters.indexOf(' ') === -1) return k < w.cells.length - 1 ? w.cells[k + 1] : i;
    if (k === w.cells.length - 1 || w.cells.slice(k + 1).every(function (c) { return (S.draft.letters[S.grid.idx[c]] || '').trim(); })) return -1;
    return w.cells[k + 1];
  }
  function moveAfterTyping(i) { var nx = advance(i); if (nx === -1) nextClue(1, true); else setFocus(nx, true); }

  function wire() {
    root.querySelectorAll('.brk-cell input').forEach(function (inp) {
      var i = Number(inp.parentNode.getAttribute('data-cell'));
      inp.addEventListener('focus', function () { if (S.focus !== i) setFocus(i, false); });
      inp.addEventListener('mousedown', function () {
        if (S.focus === i && document.activeElement === inp) { S.dir = S.dir === 'across' ? 'down' : 'across'; setTimeout(function () { setFocus(i, false); }, 0); }
      });
      inp.addEventListener('keydown', function (e) {
        if (e.metaKey || e.ctrlKey || e.altKey) return;
        var k = e.key;
        if (k === 'Tab') { e.preventDefault(); nextClue(e.shiftKey ? -1 : 1); return; }
        if (k === 'Enter') { e.preventDefault(); if (!locked()) doCheck(); return; }
        if (k === 'ArrowRight' || k === 'ArrowLeft' || k === 'ArrowUp' || k === 'ArrowDown') {
          e.preventDefault();
          var horiz = k === 'ArrowRight' || k === 'ArrowLeft', want = horiz ? 'across' : 'down';
          if (S.dir !== want && wordAt(i, want)) { S.dir = want; setFocus(i, false); return; }
          setFocus(stepCell(i, horiz ? 0 : (k === 'ArrowDown' ? 1 : -1), horiz ? (k === 'ArrowRight' ? 1 : -1) : 0), true);
          return;
        }
        if (k === ' ') { e.preventDefault(); var o = S.dir === 'across' ? 'down' : 'across'; if (wordAt(i, o)) S.dir = o; setFocus(i, false); return; }
        if (locked()) { if (k.length === 1 || k === 'Backspace') e.preventDefault(); return; }
        if (k === 'Backspace' || k === 'Delete') {
          e.preventDefault();
          if ((inp.value || '').trim()) { setLetter(i, ''); return; }
          var w = wordAt(i, S.dir), pos = w ? w.cells.indexOf(i) : -1;
          if (pos > 0) { setLetter(w.cells[pos - 1], ''); setFocus(w.cells[pos - 1], true); }
          return;
        }
        if (/^[a-zA-Z0-9]$/.test(k)) { e.preventDefault(); setLetter(i, k.toUpperCase()); moveAfterTyping(i); }
      });
      // Phones, paste and autofill can insert several letters at once: spread them along the word.
      inp.addEventListener('input', function (e) {
        if (locked()) { inp.value = (S.draft.letters[S.grid.idx[i]] || '').trim(); return; }
        var chars = norm(e.data != null ? e.data : inp.value);
        if (!chars) { setLetter(i, ''); return; }
        var cur = i, w = wordAt(i, S.dir);
        for (var m = 0; m < chars.length; m++) {
          setLetter(cur, chars[m]);
          var pos = w ? w.cells.indexOf(cur) : -1;
          if (pos < 0 || pos >= w.cells.length - 1) break;
          cur = w.cells[pos + 1];
        }
        if (chars.length === 1) moveAfterTyping(i); else setFocus(cur, true);
      });
    });
    root.querySelectorAll('.brk-clues li').forEach(function (li) {
      li.addEventListener('click', function () {
        S.dir = li.getAttribute('data-dir');
        var cells = S.grid.words[S.dir][Number(li.getAttribute('data-n'))];
        if (cells) setFocus(cells[0], true);
      });
    });
    root.querySelector('[data-prev]').addEventListener('click', function () { nextClue(-1); });
    root.querySelector('[data-next]').addEventListener('click', function () { nextClue(1); });
    root.querySelector('[data-flip]').addEventListener('click', function () {
      if (S.focus < 0) return;
      var other = S.dir === 'across' ? 'down' : 'across';
      if (wordAt(S.focus, other)) S.dir = other;
      setFocus(S.focus, true);
    });
    root.querySelector('[data-check]').addEventListener('click', doCheck);
    root.querySelector('[data-giveup]').addEventListener('click', confirmGiveUp);
    root.querySelector('[data-results]').addEventListener('click', openResults);
  }

  function updateButtons() {
    var check = root.querySelector('[data-check]'), give = root.querySelector('[data-giveup]'), res = root.querySelector('[data-results]');
    if (!check) return;
    if (solved()) { check.disabled = true; check.textContent = 'Solved'; }
    else if (gaveUp()) { check.disabled = true; check.textContent = 'Answers shown'; }
    else { check.disabled = false; check.textContent = 'Check answers →'; }
    give.hidden = !(S.player && !locked() && (S.solve || !S.puzzle.live));
    res.hidden = !(S.solve && S.player);
    var pz = root.querySelector('[data-pause]'); if (pz) pz.hidden = locked();
  }

  function submission() {
    if (S.mode === 'form') return S.draft.sub.slice();
    var sub = S.puzzle.parts.map(function () { return ''; });
    sub[S.partIndex] = S.draft.letters;
    return sub;
  }

  function applyResults(results) {
    if (S.mode === 'sudoku') return sudokuResults(results);
    if (S.mode === 'form') return formResults(results);
    var res = results && results[S.partIndex];
    if (!res || res.type !== 'grid') return;
    var g = S.grid;
    root.querySelectorAll('.brk-cell[data-cell]').forEach(function (el) {
      var ok = res.cells[g.idx[Number(el.getAttribute('data-cell'))]];
      el.classList.toggle('is-good', !!ok);
      el.classList.toggle('is-bad', !ok);
    });
  }

  function markRevealed() {
    if (S.mode === 'sudoku') return sudokuRevealed();
    if (S.mode === 'form') return formRevealed();
    var g = S.grid, letters = S.draft.letters;
    root.querySelectorAll('.brk-cell[data-cell]').forEach(function (el) {
      var i = Number(el.getAttribute('data-cell'));
      el.querySelector('input').value = (letters[g.idx[i]] || '').trim();
      el.classList.remove('is-good', 'is-bad'); el.classList.add('is-revealed');
    });
  }

  function setStatus(t) { var s = root.querySelector('[data-status]'); if (s) s.textContent = t || ''; }

  function doCheck() {
    if (locked()) return;
    if (!store(TOKEN_KEY)) { openGate('check'); return; }
    var btn = root.querySelector('[data-check]');
    btn.disabled = true; setStatus('Checking…');
    api('POST', '/api/check', { puzzle_id: S.puzzle.id, answers: submission(), seconds: elapsed() }).then(function (d) {
      setStatus('');
      S.check = d; S.solve = d.solve; S.player = d.player;
      if (d.teaser) S.puzzle.teaser = d.teaser;
      if (d.meta_letter) S.puzzle.meta_letter = d.meta_letter;
      if (d.answers) S.puzzle.answers = d.answers;
      if (d.explanation) S.puzzle.explanation = d.explanation;
      applyResults(d.results);
      refreshTop();
      updateButtons();
      openResults();
    }, function (e) {
      btn.disabled = false;
      if (e.status === 401) { store(TOKEN_KEY, null); S.player = null; setStatus(''); refreshTop(); openGate('check'); return; }
      setStatus(e.message);
    });
  }


  // ---------- shared board pieces ----------
  function boardActions() {
    return '<div class="brk-actions">' +
        '<button type="button" class="btn-orange" data-check>Check answers →</button>' +
        '<button type="button" class="brk-link" data-results hidden>Your result</button>' +
        '<button type="button" class="brk-link brk-giveup" data-giveup hidden>Give up</button>' +
        '<span class="brk-small" data-status role="status"></span>' +
      '</div>';
  }
  function howPanel(lines) {
    return '<section class="brk-clues brk-how" aria-label="How to play"><div class="brk-clues__col"><h3>How to play</h3><div class="brk-how__box">' +
      lines.map(function (l) { return '<p>' + esc(l) + '</p>'; }).join('') + '</div></div></section>';
  }
  function wireActions() {
    root.querySelector('[data-check]').addEventListener('click', doCheck);
    root.querySelector('[data-giveup]').addEventListener('click', confirmGiveUp);
    root.querySelector('[data-results]').addEventListener('click', openResults);
  }
  function rich(s) {
    return String(s || '').split(/\n{2,}/).map(function (para) {
      return '<p>' + esc(para).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>').replace(/\n/g, '<br>') + '</p>';
    }).join('');
  }

  // ---------- sudoku ----------
  function openSudoku(p, solve) {
    var part = p.parts[0];
    S.mode = 'sudoku'; S.puzzle = p; S.solve = solve; S.check = null; S.view = 'puzzle';
    S.part = part; S.partIndex = 0;
    var n = part.size;
    S.sq = { n: n, br: part.box_rows, bc: part.box_cols, givens: part.givens, focus: -1 };
    var start = part.givens.split('').map(function (ch) { return /[1-9]/.test(ch) ? ch : ' '; }).join('');
    var d = null;
    try { d = JSON.parse(store(draftKey(p.id)) || 'null'); } catch (e) {}
    S.draft = d && typeof d.letters === 'string' && d.letters.length === n * n ? d : { letters: start, started: null };
    var sub = solve && solve.submission && solve.submission[0];
    if (typeof sub === 'string' && sub.length === n * n) S.draft.letters = sub;
    if (gaveUp() && p.answers) S.draft.letters = String(p.answers[0]);
    var cells = '';
    for (var i = 0; i < n * n; i++) {
      var r = Math.floor(i / n), c = i % n;
      var cls = 'brk-cell brk-sq' + (c % S.sq.bc === S.sq.bc - 1 && c < n - 1 ? ' bx-r' : '') + (r % S.sq.br === S.sq.br - 1 && r < n - 1 ? ' bx-b' : '');
      if (/[1-9]/.test(part.givens[i])) { cells += '<div class="' + cls + ' is-given" data-cell="' + i + '"><span>' + part.givens[i] + '</span></div>'; continue; }
      var v = (S.draft.letters[i] || ' ').trim();
      cells += '<div class="' + cls + '" data-cell="' + i + '"><input id="brk-c-' + i + '" inputmode="numeric" autocomplete="off" aria-label="Row ' + (r + 1) + ', column ' + (c + 1) + '" value="' + esc(v) + '"></div>';
    }
    var pad = '';
    for (var k = 1; k <= n; k++) pad += '<button type="button" data-digit="' + k + '">' + k + '</button>';
    pad += '<button type="button" data-digit="" aria-label="Erase">⌫</button>';
    S.how = [
      'Fill every row, every column and every box with the numbers 1 to ' + n + '. Each number appears once in each.',
      'Pick a square, then type a number or tap one below the grid.',
      'Numbers that clash turn red, so you can spot a slip before you check.'
    ].concat(p.how ? [p.how] : []);
    frame(
      '<main class="brk-main">' +
        '<div class="brk-gridbox"><div class="brk-grid brk-grid--sudoku" style="--cols:' + n + ';--rows:' + n + '" role="grid" aria-label="Sudoku, ' + n + ' by ' + n + '">' + cells + '</div></div>' +
        '<div class="brk-pad" style="--keys:' + (n + 1) + '">' + pad + '</div>' +
        boardActions() +
      '</main>',
      howPanel(S.how),
      puzzleTop(p)
    );
    root.querySelectorAll('.brk-sq input').forEach(function (inp) {
      var i = Number(inp.parentNode.getAttribute('data-cell'));
      inp.addEventListener('focus', function () { S.sq.focus = i; sqHighlight(); });
      inp.addEventListener('keydown', function (e) {
        if (e.metaKey || e.ctrlKey || e.altKey) return;
        var k = e.key;
        var mv = { ArrowRight: [0, 1], ArrowLeft: [0, -1], ArrowDown: [1, 0], ArrowUp: [-1, 0] }[k];
        if (mv) { e.preventDefault(); sqMove(i, mv[0], mv[1]); return; }
        if (k === 'Enter') { e.preventDefault(); doCheck(); return; }
        if (k === 'Tab') return;
        e.preventDefault();
        if (locked()) return;
        if (k === 'Backspace' || k === 'Delete' || k === '0' || k === ' ') { sqSet(i, ''); return; }
        if (new RegExp('^[1-' + n + ']$').test(k)) sqSet(i, k);
      });
      inp.addEventListener('input', function (e) {
        if (locked()) { inp.value = (S.draft.letters[i] || '').trim(); return; }
        var v = String(e.data != null ? e.data : inp.value).replace(new RegExp('[^1-' + n + ']', 'g'), '').slice(-1);
        sqSet(i, v);
      });
    });
    root.querySelectorAll('.brk-pad button').forEach(function (b) {
      b.addEventListener('mousedown', function (e) { e.preventDefault(); });
      b.addEventListener('click', function () {
        if (locked() || S.sq.focus < 0) return;
        sqSet(S.sq.focus, b.getAttribute('data-digit'));
        var inp = cellInput(S.sq.focus); if (inp) inp.focus({ preventScroll: true });
      });
    });
    wireActions();
    updateButtons();
    if (solve) applyResults(solve.results);
    if (gaveUp()) markRevealed();
    var first = -1;
    for (var j = 0; j < n * n; j++) if (!/[1-9]/.test(part.givens[j]) && !(S.draft.letters[j] || '').trim()) { first = j; break; }
    if (first < 0) for (var m = 0; m < n * n; m++) if (!/[1-9]/.test(part.givens[m])) { first = m; break; }
    S.sq.focus = first;
    if (!locked() && window.matchMedia('(hover: hover)').matches) { var fi = cellInput(first); if (fi) fi.focus({ preventScroll: true }); }
    sqHighlight();
    tick();
  }
  function sqSet(i, v) {
    var s = S.draft.letters.split(''); s[i] = v || ' '; S.draft.letters = s.join('');
    var inp = cellInput(i); if (inp) inp.value = v || '';
    var cell = inp && inp.parentNode; if (cell) cell.classList.remove('is-good', 'is-bad');
    touch(); saveDraft(); sqHighlight();
  }
  function sqMove(i, dr, dc) {
    var n = S.sq.n, r = Math.floor(i / n) + dr, c = (i % n) + dc;
    while (r >= 0 && c >= 0 && r < n && c < n) {
      var j = r * n + c;
      if (!/[1-9]/.test(S.sq.givens[j])) { var inp = cellInput(j); if (inp) inp.focus({ preventScroll: true }); return; }
      r += dr; c += dc;
    }
  }
  function sqHighlight() {
    var q = S.sq, n = q.n, f = q.focus, L = S.draft.letters;
    var box = function (i) { return Math.floor(Math.floor(i / n) / q.br) * 100 + Math.floor((i % n) / q.bc); };
    var clash = {};
    for (var i = 0; i < n * n; i++) {
      var v = (L[i] || '').trim(); if (!v) continue;
      for (var j = i + 1; j < n * n; j++) {
        if ((L[j] || '').trim() !== v) continue;
        if (Math.floor(i / n) === Math.floor(j / n) || i % n === j % n || box(i) === box(j)) { clash[i] = clash[j] = true; }
      }
    }
    var fv = f >= 0 ? (L[f] || '').trim() : '';
    root.querySelectorAll('.brk-sq').forEach(function (el) {
      var i = Number(el.getAttribute('data-cell'));
      var peer = f >= 0 && (Math.floor(i / n) === Math.floor(f / n) || i % n === f % n || box(i) === box(f));
      el.classList.toggle('is-word', peer && i !== f);
      el.classList.toggle('is-focus', i === f);
      el.classList.toggle('is-same', !!fv && (L[i] || '').trim() === fv && i !== f);
      el.classList.toggle('is-clash', !!clash[i] && !el.classList.contains('is-given'));
    });
  }
  function sudokuResults(results) {
    var res = results && results[0]; if (!res) return;
    root.querySelectorAll('.brk-sq:not(.is-given)').forEach(function (el) {
      var ok = res.cells[Number(el.getAttribute('data-cell'))];
      el.classList.toggle('is-good', !!ok); el.classList.toggle('is-bad', !ok);
    });
  }
  function sudokuRevealed() {
    var L = S.draft.letters;
    root.querySelectorAll('.brk-sq:not(.is-given)').forEach(function (el) {
      var i = Number(el.getAttribute('data-cell'));
      el.querySelector('input').value = (L[i] || '').trim();
      el.classList.remove('is-good', 'is-bad', 'is-clash'); el.classList.add('is-revealed');
    });
  }

  // ---------- something weirder: ciphers, riddles, logic ----------
  function openForm(p, solve) {
    S.mode = 'form'; S.puzzle = p; S.solve = solve; S.check = null; S.view = 'puzzle'; S.partIndex = 0;
    var d = null;
    try { d = JSON.parse(store(draftKey(p.id)) || 'null'); } catch (e) {}
    S.draft = d && Array.isArray(d.sub) && d.sub.length === p.parts.length ? d : { sub: p.parts.map(function () { return ''; }), started: null };
    if (solve && Array.isArray(solve.submission) && solve.submission.length === p.parts.length) S.draft.sub = solve.submission.slice();
    if (gaveUp() && p.answers) S.draft.sub = formAnswers();
    var multi = p.parts.length > 1;
    var parts = p.parts.map(function (part, i) {
      var legend = multi ? '<legend class="brk-legend">Part ' + (i + 1) + '</legend>' : '<legend class="visually-hidden">Your answer</legend>';
      var val = S.draft.sub[i];
      if (part.type === 'choice') {
        return '<fieldset class="brk-part" data-part="' + i + '">' + legend + '<div class="brk-prompt">' + esc(part.prompt) + '</div><div class="brk-options">' +
          part.options.map(function (o, k) {
            var id = 'brk-opt-' + i + '-' + k;
            return '<label class="brk-option" for="' + id + '"><input type="radio" id="' + id + '" name="brk-choice-' + i + '" value="' + k + '"' + (String(val) === String(k) && val !== '' ? ' checked' : '') + '><span>' + esc(o) + '</span></label>';
          }).join('') + '</div><span class="brk-mark" aria-live="polite"></span></fieldset>';
      }
      var tid = 'brk-text-' + i;
      return '<fieldset class="brk-part" data-part="' + i + '">' + legend +
        '<label class="brk-prompt" for="' + tid + '">' + esc(part.prompt) + (part.length ? ' <span class="brk-len">(' + esc(part.length) + ')</span>' : '') + '</label>' +
        '<input class="brk-input brk-answer" id="' + tid + '" type="text" autocomplete="off" autocapitalize="characters" spellcheck="false" enterkeyhint="go" value="' + esc(val) + '">' +
        '<span class="brk-mark" aria-live="polite"></span></fieldset>';
    }).join('');
    var how = [p.how || 'Read it, work it out, type your answer, then press Check.'];
    if (!p.how && p.parts.some(function (x) { return x.type === 'text'; })) how.push('Spelling counts. Capitals, spaces and punctuation don’t.');
    S.how = how;
    frame(
      '<main class="brk-main brk-main--form">' +
        '<div class="brk-formbody">' +
          '<h1 class="brk-main__title">' + esc(p.title) + '</h1>' +
          (p.intro ? '<div class="brk-intro">' + rich(p.intro) + '</div>' : '') +
          (p.code ? '<pre class="brk-code">' + esc(p.code) + '</pre>' : '') +
          (p.image ? '<img class="brk-image" src="' + esc(p.image) + '" alt="">' : '') +
          '<div class="brk-parts">' + parts + '</div>' +
        '</div>' +
        boardActions() +
      '</main>',
      howPanel(how),
      puzzleTop(p)
    );
    p.parts.forEach(function (part, i) {
      var wrap = root.querySelector('[data-part="' + i + '"]');
      var clear = function () { wrap.classList.remove('is-good', 'is-bad'); wrap.querySelector('.brk-mark').textContent = ''; };
      if (part.type === 'choice') {
        wrap.querySelectorAll('input').forEach(function (r) {
          r.addEventListener('change', function () { if (locked()) return; S.draft.sub[i] = Number(r.value); touch(); saveDraft(); clear(); });
        });
      } else {
        var inp = wrap.querySelector('input');
        inp.addEventListener('input', function () { if (locked()) { inp.value = S.draft.sub[i]; return; } S.draft.sub[i] = inp.value; touch(); saveDraft(); clear(); });
        inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); doCheck(); } });
      }
    });
    wireActions();
    updateButtons();
    if (solve) applyResults(solve.results);
    if (gaveUp()) markRevealed();
    if (locked()) root.querySelectorAll('.brk-parts input').forEach(function (x) { if (x.type === 'radio') x.disabled = true; else x.readOnly = true; });
    else if (window.matchMedia('(hover: hover)').matches) { var first = root.querySelector('.brk-answer'); if (first) first.focus({ preventScroll: true }); }
    tick();
  }
  function formAnswers() {
    return S.puzzle.parts.map(function (part, i) { var a = S.puzzle.answers[i]; return part.type === 'choice' ? Number(a) : Array.isArray(a) ? a[0] : a; });
  }
  function formResults(results) {
    (results || []).forEach(function (res, i) {
      var wrap = root.querySelector('[data-part="' + i + '"]'); if (!wrap) return;
      wrap.classList.toggle('is-good', !!res.correct); wrap.classList.toggle('is-bad', !res.correct);
      wrap.querySelector('.brk-mark').textContent = res.correct ? 'Right' : 'Not quite';
    });
  }
  function formRevealed() {
    var a = S.draft.sub;
    S.puzzle.parts.forEach(function (part, i) {
      var wrap = root.querySelector('[data-part="' + i + '"]'); if (!wrap) return;
      if (part.type === 'choice') { var r = wrap.querySelector('input[value="' + a[i] + '"]'); if (r) r.checked = true; }
      else wrap.querySelector('input').value = a[i];
      wrap.classList.remove('is-good', 'is-bad'); wrap.classList.add('is-revealed');
      wrap.querySelector('.brk-mark').textContent = 'Answer';
      wrap.querySelectorAll('input').forEach(function (x) { if (x.type === 'radio') x.disabled = true; else x.readOnly = true; });
    });
  }

  // ---------- popups ----------
  function popup(html, opts) {
    var old = document.querySelector('.brk-scrim'); if (old) old.remove();
    var scrim = document.createElement('div');
    scrim.className = 'brk-scrim';
    scrim.innerHTML = html;
    document.body.appendChild(scrim);
    document.documentElement.classList.add('brk-locked');
    var opener = document.activeElement;
    var closed = false;
    var close = function () {
      if (closed) return; closed = true;
      scrim.remove(); document.documentElement.classList.remove('brk-locked');
      document.removeEventListener('keydown', onKey);
      if (opts && opts.onClose) opts.onClose();
      else if (opener && opener.focus) opener.focus({ preventScroll: true });
    };
    var onKey = function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = [].filter.call(scrim.querySelectorAll('input, button, a[href]'), function (x) { return !x.disabled && x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    };
    document.addEventListener('keydown', onKey);
    scrim.addEventListener('mousedown', function (e) { if (e.target === scrim) close(); });
    scrim.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', close); });
    return { el: scrim, close: close };
  }

  function confirmGiveUp() {
    var pop = popup(
      '<div class="brk-pop" role="alertdialog" aria-modal="true" aria-labelledby="brk-gu-h" aria-describedby="brk-gu-d">' +
        '<div class="label accent">Break ' + esc(breakNo(S.puzzle.id)) + '</div>' +
        '<h2 id="brk-gu-h" class="brk-pop__h">Are you sure<br>you <span class="accent">give up?</span></h2>' +
        '<p id="brk-gu-d" class="brk-small">You’ll see every answer, and this puzzle won’t earn you a letter for Friday.' +
          (S.puzzle.live ? ' Your streak still counts.' : '') + '</p>' +
        '<button type="button" class="btn-orange" data-close data-keep>Keep trying</button>' +
        '<button type="button" class="brk-link" data-yes>Yes, I give up</button>' +
      '</div>');
    pop.el.querySelector('[data-yes]').addEventListener('click', function () { pop.close(); doReveal(); });
    setTimeout(function () { pop.el.querySelector('[data-keep]').focus(); }, 30);
  }

  function doReveal() {
    api('POST', '/api/reveal', { puzzle_id: S.puzzle.id }).then(function (d) {
      S.puzzle.answers = d.answers; S.puzzle.explanation = d.explanation;
      S.solve = d.solve || S.solve;
      if (S.solve) S.solve.revealed = true;
      if (S.mode === 'form') S.draft.sub = formAnswers(); else S.draft.letters = norm(d.answers[S.partIndex]);
      saveDraft();
      markRevealed();
      updateButtons();
      openResults();
    }, function (e) { setStatus(e.message); });
  }

  function answerLine() {
    if (S.mode === 'sudoku') return '';
    if (S.mode === 'form') return S.puzzle.parts.map(function (part, i) {
      var a = S.puzzle.answers[i], shown = part.type === 'choice' ? part.options[Number(a)] : Array.isArray(a) ? a[0] : a;
      return '<span>' + (S.puzzle.parts.length > 1 ? '<b>' + (i + 1) + '</b> ' : '') + esc(shown) + '</span>';
    }).join('');
    var g = S.grid, letters = norm(S.puzzle.answers[S.partIndex]), out = [];
    ['across', 'down'].forEach(function (dir) {
      Object.keys(g.words[dir]).forEach(function (n) {
        var w = g.words[dir][n].map(function (c) { return letters[g.idx[c]]; }).join('');
        out.push('<span><b>' + n + (dir === 'across' ? 'A' : 'D') + '</b> ' + esc(w) + '</span>');
      });
    });
    return out.join('');
  }

  function shareText() {
    var p = S.puzzle, sv = S.solve || {}, ck = S.check;
    var line = solved() ? 'Solved in ' + fmtTime(sv.seconds) : gaveUp() ? 'Gave up' : (ck ? ck.score : sv.score) + '/' + (ck ? ck.total : sv.total) + ' in ' + fmtTime(sv.seconds);
    return 'Decca Coffee Break Puzzles ' + breakNo(p.id) + '\n' + line + (S.player ? ' · ' + S.player.streak + '-day streak' : '') + '\n' + location.origin + location.pathname;
  }

  function openResults() {
    var p = S.puzzle, pl = S.player, ck = S.check, sv = S.solve;
    if (!sv || !pl) return;
    var score = ck ? ck.score : sv.score, total = ck ? ck.total : sv.total;
    var ok = solved(), gu = gaveUp();
    var letter = ok ? ((ck && ck.meta_letter) || p.meta_letter) : '';
    var head = ok ? 'Clean <span class="accent">solve.</span>' : gu ? 'Next time<span class="accent">.</span>' : total === 1 ? 'Not <span class="accent">quite.</span>' : score + ' of ' + total + ' <span class="accent">right.</span>';
    var timing = sv.on_time ? 'On time' : 'Late';
    var pop = popup(
      '<div class="brk-pop brk-pop--result" role="dialog" aria-modal="true" aria-labelledby="brk-res-h">' +
        '<div class="brk-pop__band">' +
          '<div class="label">' + (ok ? 'Solved' : gu ? 'Gave up' : 'Checked') + ' · Break ' + esc(breakNo(p.id)) + '</div>' +
          '<h2 id="brk-res-h" class="brk-pop__h">' + head + '</h2>' +
          '<div class="brk-stats">' +
            '<div><b>' + fmtTime(sv.seconds) + '</b><span>Time</span></div>' +
            '<div><b>' + (sv.first_correct ? 'First try' : sv.attempts + (sv.attempts === 1 ? ' check' : ' checks')) + '</b><span>Checks</span></div>' +
            '<div><b>' + timing + '</b><span>Streak</span></div>' +
          '</div>' +
        '</div>' +
        '<div class="brk-pop__body">' +
          (letter ? '<div class="brk-meta">Your letter for Friday <b>' + esc(letter) + '</b></div>' : '') +
          (ok && /weekly/i.test(p.kind || '') ? '<div class="brk-prize"><b>You cracked the weekly puzzle.</b><span>Screenshot it and DM it to @deccadecaf on Instagram. The first finished puzzle we get wins this week’s prize.</span><a class="brk-btn-ghost" href="' + esc(instagram()) + '" target="_blank" rel="noopener">See it on ' + esc(copy('instagram_handle', '@deccadecaf')) + '</a></div>' : '') +
          (!ok && !gu ? '<p class="brk-small">' + (S.mode === 'form' ? 'Not quite. Try again.' : 'The red squares are wrong. Fix them and check again.') + ' Today already counts toward your streak.</p>' : '') +
          (gu ? '<p class="brk-small">Your streak still counts. This one won’t earn a letter for Friday.</p>' : '') +
          ((ok || gu) && p.answers ? '<p class="brk-answers">' + answerLine() + '</p>' : '') +
          (p.explanation && (ok || gu) ? '<p class="brk-small">' + esc(p.explanation) + '</p>' : '') +
          '<div class="brk-pop__row">' +
            '<div class="brk-me__streak"><span class="brk-me__n">' + pl.streak + '</span><span class="brk-me__l">day<br>streak</span></div>' +
            weekDots(pl.week) +
          '</div>' +
          (p.live ? '<div class="brk-pop__next"><span class="label">Next puzzle</span><span class="brk-count" data-countdown></span></div>' +
            (p.teaser ? '<p class="brk-small">' + esc(p.teaser) + '</p>' : '') : '') +
          '<div class="brk-share"><pre data-share>' + esc(shareText()) + '</pre><button type="button" class="brk-btn-ghost" data-copy>Copy result</button><span class="brk-small" data-copied role="status"></span></div>' +
          '<div class="brk-pop__actions">' +
            '<button type="button" class="btn-orange" data-close>' + (ok || gu ? 'Back to the grid' : 'Keep solving') + '</button>' +
            '<a class="text-link" href="#archive" data-close>Play past puzzles</a>' +
          '</div>' +
        '</div>' +
      '</div>',
      { onClose: function () { if (!locked() && S.view === 'puzzle' && S.mode === 'crossword') setFocus(S.focus >= 0 ? S.focus : firstEmpty(), true); } });
    var el = pop.el;
    el.querySelector('[data-copy]').addEventListener('click', function () {
      var t = shareText(), msg = el.querySelector('[data-copied]');
      var fallback = function () {
        var r = document.createRange(); r.selectNodeContents(el.querySelector('[data-share]'));
        var s = getSelection(); s.removeAllRanges(); s.addRange(r); msg.textContent = 'Selected. Copy it with your keyboard.';
      };
      try { navigator.clipboard.writeText(t).then(function () { msg.textContent = 'Copied'; }, fallback); } catch (e) { fallback(); }
    });
    tick();
    setTimeout(function () { var b = el.querySelector('.btn-orange'); if (b) b.focus(); }, 30);
  }

  function openGate(reason) {
    var heads = {
      check: 'See how you <span class="accent">did.</span>',
      archive: 'Open the<br><span class="accent">archive.</span>',
      notify: 'Get it at<br><span class="accent">3 PM.</span>',
      login: 'Sign in with<br>your <span class="accent">email.</span>'
    };
    var t = S.draft && S.draft.started && !S.solve && S.view === 'puzzle' ? fmtTime(elapsed()) : '';
    var pop = popup(
      '<form class="brk-pop" role="dialog" aria-modal="true" aria-labelledby="brk-gate-h" novalidate>' +
        '<div class="label accent">' + (t ? 'You’re ' + t + ' in' : 'Coffee Break Puzzles') + '</div>' +
        '<h2 id="brk-gate-h" class="brk-pop__h">' + (heads[reason] || heads.check) + '</h2>' +
        (reason === 'login' ? '<p class="brk-small">Enter your email to sign in and unlock your streak and your past answers.</p>' :
          '<ul class="brk-pop__list"><li>Check today’s answers</li><li>Start your streak</li><li>Get each new puzzle by email at 3 PM ET</li><li>Play every past puzzle</li></ul>') +
        '<div class="brk-field"><label for="brk-gate-email" class="label">Email address</label>' +
        '<input id="brk-gate-email" class="brk-input" type="email" autocomplete="email" inputmode="email" placeholder="you@email.com" required>' +
        '<span class="brk-pop__err" data-err role="alert"></span></div>' +
        '<label class="brk-optin"><input type="checkbox" data-optin><span>' + esc(copy('optin_text', 'Send me updates from Decca too: new flavors, merch drops, and fun stuff.')) + '</span></label>' +
        '<button type="submit" class="btn-orange">' + (reason === 'check' ? 'Check my answers →' : reason === 'archive' ? 'Open the archive →' : reason === 'login' ? 'Sign in →' : 'Count me in →') + '</button>' +
        '<p class="brk-small">You’ll get one puzzle email each weekday at 3 PM ET. Unsubscribe anytime.</p>' +
        '<button type="button" class="brk-link" data-close>' + (reason === 'check' ? 'Just keep playing' : 'Not now') + '</button>' +
      '</form>');
    var form = pop.el.querySelector('form'), input = pop.el.querySelector('input'), err = pop.el.querySelector('[data-err]');
    input.addEventListener('input', function () { err.textContent = ''; });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = input.value.trim();
      if (!v) { err.textContent = 'Enter your email to keep going.'; input.focus(); return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { err.textContent = 'That email looks off. Check it and try again.'; input.focus(); return; }
      var btn = form.querySelector('button[type=submit]'); btn.disabled = true;
      api('POST', '/api/players', { email: v, source: source(), decca_updates: form.querySelector('[data-optin]').checked }).then(function (d) {
        store(TOKEN_KEY, d.token); S.player = d.player;
        pop.close();
        if (reason === 'check' && S.puzzle) { refreshTop(); updateButtons(); doCheck(); }
        else if (reason === 'archive') { if (location.hash === '#archive') showArchive(); else location.hash = 'archive'; }
        else route();
      }, function (e2) { btn.disabled = false; err.textContent = e2.message; });
    });
    setTimeout(function () { input.focus(); }, 30);
  }

  // ---------- archive ----------
  function showArchive() {
    if (!store(TOKEN_KEY)) { location.hash = ''; openGate('archive'); return; }
    loading();
    Promise.all([api('GET', '/api/archive'), api('GET', '/api/me')]).then(function (r) {
      S.player = r[1].player; S.view = 'archive'; S.puzzle = null;
      var rows = r[0].puzzles.map(function (z) {
        var status = z.live ? '<span class="brk-chip is-orange">Live</span>' : z.played ? (z.correct ? '<span class="brk-ok">Solved</span>' : '<span>Played</span>') : '<span class="brk-dim">New</span>';
        return '<a class="brk-arow" href="' + (z.live ? '#play' : '#break-' + z.id) + '">' +
          '<span class="brk-arow__no">' + esc(breakNo(z.id)) + '</span>' +
          '<span class="brk-arow__t"><b>' + esc(z.title) + '</b><small>' + esc(longDate(z.date)) + ' · ' + esc(z.difficulty) + '</small></span>' +
          '<span class="brk-arow__s">' + status + '</span>' +
          '<span class="brk-arow__time">' + (z.seconds != null ? fmtTime(z.seconds) : '') + '</span></a>';
      }).join('');
      frame(
        '<main class="brk-main brk-main--archive">' +
          '<h1 class="brk-main__title">Every puzzle so far</h1>' +
          '<p class="brk-small">Solve an old one to earn its letter for the weekly puzzle. Only today’s puzzle counts toward your streak.</p>' +
          '<div class="brk-arch">' + (rows || '<p class="brk-small">Puzzles land here the day after they run.</p>') + '</div>' +
        '</main>'
      , null, toolbar({ back: '#', label: '<b>Archive</b>' }));
    }, function (e) {
      if (e.status === 401) { store(TOKEN_KEY, null); S.player = null; location.hash = ''; openGate('archive'); return; }
      errorView(e, showArchive);
    });
  }

  // ---------- clock ----------
  function tick() {
    var t = root.querySelector('[data-timer]');
    if (t) t.textContent = fmtClock(elapsed());
    var c = document.querySelectorAll('[data-countdown]');
    if (c.length && S.nextRelease) {
      var left = new Date(S.nextRelease).getTime() - Date.now();
      c.forEach(function (el) { el.textContent = fmtCountdown(left); });
      if (left <= 0 && !S.reloading && !document.querySelector('.brk-scrim')) {
        S.reloading = true; setTimeout(function () { S.reloading = false; if (!location.hash) showToday(false); }, 2000);
      }
    }
  }
  setInterval(tick, 1000);

  route();
})();
